import { Info } from 'lucide-react';

import { Tooltip } from '@/components/Tooltip/Tooltip';

import styles from './InstructorSentimentInfo.module.css';

export function InstructorSentimentInfo() {
  return (
    <Tooltip content="This overlay shows where students pressed 'I'm Confused' during this video. Redder areas indicate more confusion. Data is cumulative and anonymous.">
      <button
        aria-label="About class confusion overlay"
        className={styles.button}
        type="button"
      >
        <Info aria-hidden="true" size={16} />
        Confusion overlay
      </button>
    </Tooltip>
  );
}
